/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import NotificationAlert from "react-notification-alert";
import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
import ChipInput from "material-ui-chip-input";
import * as Utils from "./Utils";
import { getAnalytics, logEvent } from "firebase/analytics";

// reactstrap components
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  CardLink,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import classnames from "classnames";

import { connect } from "react-redux";
// import CommentsBlock from "simple-react-comments";
function Learn(props) {
  //first, set profile info hooks
  const [lists, setLists] = useState([]);

  function getLists() {
    let xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://zirostudio.appspot.com/fetchpublicplaylists"
    );

    console.log("SENDING REQUESTS");
  
    xhr.onload = function () {
      if ("status" in JSON.parse(xhr.responseText)) {
        return;
      }
      if(xhr.status === 200){
        var curList = JSON.parse(xhr.response);
        // var reorderedList = [curList[0], curList[2], curList[1], curList[3], curList[4]];
        setLists(curList);
      } else {
        console.log("Error fetching lists.")
      }
    };
    xhr.send();
  }

  useEffect(() => {
    getLists();
    logEvent(getAnalytics(), 'on_learn_page')
  }, []);
  
  return (
    <>
      <div className="content">
        <Col md="12">
          <Row>
            <Card
              className="card-tasks"
              style={{ height: "100%", "overflow-x": "hidden" }}
            >
              <CardHeader>
                <Row>
                  <Col>
                    <h2 className="title d-inline">Tutorial Videos</h2>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {/*Link to YouTube*/}
                    <a href="https://www.youtube.com/playlist?list=PLhZO0S54alB7d8ggkAZH79EY3CBU0XmaZ" target="_blank">
                      <Button style={{marginBottom: 20}}>
                        View Playlist
                      </Button>
                    </a>                  
                  </Col>
                </Row>
              </CardHeader>
            </Card>
            <Card
              className="card-tasks"
              style={{ height: "100%", "overflow-x": "hidden" }}
            >
              <CardHeader>
                <Row>
                  <Col>
                    <h2 className="title d-inline">Tutorial Lists</h2>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  {lists.map((listItem, listIndex) => {
                    return (
                      <Col md={4} style={{ marginBottom: 20 }}>
                        <Card className="" style={{ height: "100%" }}>
                          <Link
                            to={
                                "/list-view?id=" +
                                listItem["playlist_id"]
                            }
                          >
                            <img
                              className="img-fluid"
                              onError={Utils.addDefaultSrc}
                              src={
                                "https://storage.googleapis.com/user-thumbnails/" +
                                listItem['project_list'].split(",")[0] + ".jpg"
                              }
                            ></img>
                          </Link>
                          <Row style={{ marginTop: -45, marginLeft: -7 }}>
                            <Col md={12}>
                              {false ? (
                                <Button
                                  className="btn-round btn-icon btn-clear"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                                    backgroundImage: "",
                                    marginBottom: 0
                                  }}
                                  onClick={() => {
                                    //deleteList(listItem["playlist_id"]);
                                  }}
                                >
                                  <i className="fa fa-trash" />
                                </Button>
                              ) : (
                                <>
                                <br></br>
                                <br></br>
                                </>
                              )}
                            </Col>
                          </Row>
                          <CardBody>
                            <CardText />
                            <Link
                              to={
                                  "/list-view?id=" +
                                  listItem["playlist_id"]
                              }
                            >
                              <h3 style={{ marginBottom: 0 }}>
                                {listItem["title"]}
                              </h3>
                            </Link>
                            <p className="description" style={Utils.descStyle}>
                              {listItem["description"]}
                            </p>
                            <Link
                              to={
                                  "/list-view?id=" +
                                  listItem["playlist_id"]
                              }
                            >
                              <a style={{ marginTop: -20 }}>
                                VIEW FULL LIST
                              </a>
                            </Link>
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Col>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  userID: state.userID,
});

export default connect(mapStateToProps)(Learn);
